// extracted by css-extract-rspack-plugin
export default {"input":"input-gy_bML","label":"label-6jL2Rd","marker":"marker-nfMCYn","dot":"dot-MhdE5X","container":"container-RdY4Qg","right":"right-Q_ZGtt","fullWidth":"fullWidth-zzGnaF"};